import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: null })
export class PageSizeService {
  static defaultPageSize = 20;

  #pageSize = signal<number>(PageSizeService.defaultPageSize);

  addPageSize(value: number): void {
    this.#pageSize.set(value);
  }

  get getPageSize(): number {
    return this.#pageSize();
  }
}
